import { makeStateKey } from '@angular/platform-browser'

export const SVG_TRANSFER_KEY = makeStateKey<{}>('cfg.ts.svg')
